<template>
    <div class="bng-history-toto">
        <div class="tabs is-small is-centered">
            <ul>
                <li @click="filter = 'all'; refresh()" :class="{ 'is-active': filter == 'all' }">
                    <a>{{"components.pages.history.toto.all bets" | translate}}</a>
                </li>
                <li
                    @click="filter = 'not settled'; refresh()"
                    :class="{ 'is-active': filter == 'not settled' }"
                >
                    <a>{{"components.pages.history.toto.not settled bets" | translate}}</a>
                </li>
                <li
                    @click="filter = 'settled'; refresh()"
                    :class="{ 'is-active': filter == 'settled' }"
                >
                    <a>{{"components.pages.history.toto.settled bets" | translate}}</a>
                </li>
            </ul>
        </div>

        <div
            v-if="!loading && (!bets || !bets.length)"
            class="box title is-5"
        >{{`components.pages.history.no ${filter}` | translate}}</div>

        <div v-else class="table-container">
            <table class="table is-striped is-hoverable is-fullwidth is-size-7 bng-nowrap">
                <thead>
                    <tr>
                        <th>{{ "components.pages.history.toto.bkid" | translate }}</th>
                        <th>{{ "components.pages.history.toto.time" | translate }}</th>
                        <th>{{ "components.pages.history.toto.draw" | translate }}</th>
                        <th>{{ "components.pages.history.toto.combinations count" | translate }}</th>
                        <th>{{ "components.pages.history.toto.bet" | translate }}</th>
                        <th>{{ "components.pages.history.toto.status" | translate }}</th>
                    </tr>
                </thead>

                <tbody v-for="(bet, betIndex) of bets" :key="`bet-${betIndex}`">
                    <tr @click="toggleBetDetails(bet);">
                        <td>
                            <template v-if="bet.showDetails">
                                <span class="icon is-small">
                                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                                </span>
                            </template>
                            <template v-else>
                                <span class="icon is-small">
                                    <i class="fas fa-angle-right" aria-hidden="true"></i>
                                </span>
                            </template>
                            {{bet.totoId}}
                        </td>
                        <td>
                            {{ bet.betDate | localDatetime }}
                        </td>
                        <td>
                            {{ bet.profileName }} #{{ bet.drawNum }}
                        </td>
                        <td>
                            {{ bet.combinationsCount }}
                        </td>
                        <td>
                            <span>{{ bet.betAmount | currency(bet.currency) }}</span>
                            <span
                                v-if="bet.stakeTaxAmount !== 0"
                                class="has-text-grey-light">+{{ bet.stakeTaxAmount | currency(bet.currency) }} (TAX {{ bet.stakeTaxFactor * 100 }}%)</span>
                        </td>
                        <!-- <td>@{{ bet.bkSelections.reduce((res, s) => res * s.factor, 1) | rate }}</td> -->
                        <td>
                            <span :class="{ 'has-text-success has-text-weight-bold': bet.resultStatus === 'won', 'has-text-grey': bet.resultStatus === 'lost'}">
                                {{ `toto.betResultStatus.${bet.resultStatus}` | translate }}
                                
                                <template v-if="bet.resultStatus === 'won'">
                                    <span>{{ bet.payoutAmount | currency(bet.currency) }}</span>
                                    <span
                                        v-if="bet.winTaxAmount !== 0"
                                        class="has-text-grey-light">+{{ bet.winTaxAmount | currency(bet.currency) }} (TAX {{ bet.winTaxFactor * 100 }}%)</span>
                                </template>
                            </span>
                        </td>
                    </tr>
                    <tr v-if="bet.showDetails">
                        <td colspan="6">
                            <div class="box">
                                <table class="table is-fullwidth">
                                    <tbody>
                                        <tr v-for="(selection, i) in bet.selections" :key="i">
                                            <td>{{ selection.num }}</td>
                                            <td>{{ selection.leagueName }}</td>
                                            <td class="has-text-weight-semibold">{{ selection.homeMemberName }} - {{ selection.awayMemberName }}</td>
                                            <td>{{ selection.startTime | localDatetime }}</td>
                                            <td>{{ selection.outcomes.join(', ') }}</td>
                                            <td>
                                                <span :class="{ 'has-text-success': selection.resultStatus === 'won', 'has-text-grey': selection.resultStatus === 'lost' }">
                                                    {{ `toto.selectionResultStatus.${selection.resultStatus}` | translate }}
                                                </span>
                                                <span v-if="selection.correctedResult">
                                                    <span
                                                        v-if="selection.correctedResult === selection.actualResult"
                                                        class="has-text-grey">
                                                        ({{ selection.correctedResult }})
                                                    </span>
                                                    <span
                                                        v-else
                                                        class="has-text-grey">
                                                        ({{ selection.actualResult }} -> {{ selection.correctedResult }})
                                                    </span>
                                                </span>
                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </tbody>

            </table> 
        </div>

        <!-- load more -->
        <div class="field">
            <a
                v-if="hasLoadMore"
                :class="[{ 'is-loading': loading }, 'button', 'is-info', 'is-rounded', 'is-fullwidth']"
                @click="loadMore();"
            >{{ "components.pages.history.load more" | translate }}</a>
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import totoService from '../../../../../../_common/services/toto.service';
export default {
    data () {
        return {
            filter: 'all',
            bets: [],
            take: 20,
            skip: 0,
            loading: false,
            hasLoadMore: true
        }
    },
    computed: {
        balance: function() {
            return Vue.state.history.balance.get();
        },
        date: function() {
            return Vue.state.history.date.get();
        }
    },
    methods: {
        async refresh() {
            this.skip = 0;
            let loadedBets = await this.getBets();
            this.bets.splice(0, this.bets.length);
            this.bets.push(...loadedBets);
            this.hasLoadMore = loadedBets.length >= this.take;
            console.log('refresh', this.bets)
        },
        async getBets() {
            this.loading = true;
            let isSettled = null;
            if (this.filter === 'not settled') {
                isSettled = false;
            } else if (this.filter === 'settled') {
                isSettled = true;
            }
            const result = await totoService.getTotoBets(this.balance.id, this.date, this.take, this.skip, isSettled);
            this.loading = false;

            return result;
        },
        async loadMore() {
            this.skip += this.take;
            let loadedBets = await this.getBets();
            this.bets.push(...loadedBets);
            this.hasLoadMore = loadedBets.length >= this.take;
        },
        toggleBetDetails(bet) {
            this.$set(bet, 'showDetails', !bet.showDetails);
        },
    },
    watch: {
        balance: async function() {
            await this.refresh();
        },
        date: async function() {
            await this.refresh();
        }
    },
    async mounted() {
        // await bkTranslatorService.init(this.$i18n.locale())
        await this.refresh();
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/history/toto.vue